module.exports = __webpack_public_path__ + "static/media/Group 66@2x.33fd8e21.png";